import styled from '@emotion/styled'

export const StyledIframe = styled.iframe<{ height: string }>(({ height }) => ({
    display: 'block',
    width: '100%',
    height,
    border: 0,
}))
